export default __webpack_public_path__ + "static/media/accept_sug.d2dc25f2.svg";